import React from "react";
import tw from "twin.macro";
import styled from "styled-components";

const Container = styled.section`
  ${tw`relative w-full font-work_sans bg-[#FFFBDC] text-[#14133B]`}
  padding: clamp(2rem, 1.5rem + 2vw, 4rem) 1.5rem clamp(1.5rem, 1rem + 1.5vw, 3rem);
`;

const Inner = tw.div`max-w-5xl mx-auto`;

const HeroFrame = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 4 / 3;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 28px 50px rgba(20, 19, 65, 0.14);
  background: #fffbdc;

  @media (min-width: 768px) {
    border-radius: 28px;
    aspect-ratio: 16 / 9;
  }
`;

const HeroImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

const HeroCaption = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: clamp(1rem, 4vw, 3rem);
  pointer-events: none;
`;

const Heading = styled.h1`
  ${tw`font-semibold tracking-tight text-white`}
  font-size: clamp(2.1rem, 1.4rem + 4.48vw, 3.85rem);
  line-height: 1.15;
  margin: 0;
  text-shadow: 0 2px 14px rgba(20, 19, 59, 0.55);
`;

const RAW_IMAGE = "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/Pita/331778797425_.pic_hd.jpg";
const HERO_IMAGE = `${RAW_IMAGE}?x-oss-process=image/resize,w_1400,m_lfit/quality,q_85/format,webp`;

const RecommendOfficeComponent = () => {
  return (
    <Container>
      <Inner>
        <HeroFrame>
          <HeroImage src={HERO_IMAGE} alt="Grain pita lunch spread" loading="lazy" />
          <HeroCaption>
            <Heading>
              Enjoy a FREE lunch!
              <br />
              Recommend your office
            </Heading>
          </HeroCaption>
        </HeroFrame>
      </Inner>
    </Container>
  );
};

export default RecommendOfficeComponent;
